import { type IntlKeys } from "@/features/translations"
import { SubscriptionFunnelType } from "../../types/funnelType"

export function getFunnelLabelTranslationKey(
    funnelType: SubscriptionFunnelType
): IntlKeys<"FunnelTypeToggle.toggle"> {
    switch (funnelType) {
        case SubscriptionFunnelType.MonoEnergyElectricity:
            return "mono.electricity"
        case SubscriptionFunnelType.MonoEnergyGas:
            return "mono.gas"
        case SubscriptionFunnelType.DualEnergy:
            return "dual"
    }
}
